import { FaHome } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

export const E404 = props => (
    <Container className="d-flex flex-column vh-100 w-100 align-items-center justify-content-center gap-5">

        <div className="text-center">
            <h1 className="display-2 text-danger fw-bold m-0">
                <FormattedMessage
                    id="label.error_404"
                    defaultMessage="Error 404"
               />
            </h1>
            <h2 className="m-0">
                <FormattedMessage
                    id="label.page_not_found"
                    defaultMessage="Page not found."
               />
            </h2>
        </div>

        <Link to="/" className="btn btn-primary d-flex align-items-center align-self-center gap-1">
            <FaHome />
            <FormattedMessage
                id="label.home"
                defaultMessage="Home"
            />
        </Link>
    </Container>
);